// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_jx-1";
export var quotedThread = "_jx-0";